import { createSyncStore } from '../factory';

export type TitleBarNudgeState = {
  showExpandModeNudge: boolean;
};

export type TitleBarNudgeActions = {
  setShowExpandModeNudge: (visible: boolean) => void;
};

export const createTitleBarNudgeStore = (origin?: string) =>
  createSyncStore<TitleBarNudgeState, TitleBarNudgeActions>({
    channel: 'title-bar-show-nudge',
    syncKeys: ['showExpandModeNudge'],
    throttleMs: 50,
    state: {
      showExpandModeNudge: false,
    },
    actions: (set) => ({
      setShowExpandModeNudge: (value: boolean) => set({ showExpandModeNudge: value }),
    }),
    syncOptions: origin ? { origin } : {},
  });
